<template>
  <v-app id="login" class="primary">
    <v-main>
      <v-container
        :class="{ 'ma-0 pa-0 h100 white_bg': $vuetify.breakpoint.xs }"
        fluid
        fill-height
      >
        <v-layout align-center justify-center>
          <v-flex xs12 md5 xl5 style="max-width:400px">
            <v-card class="elevation-0 pa-3">
              <v-layout wrap justify-center>
                <v-flex style="max-width:200px" class="xs10 ma-2 pa-2">
                  <v-img
                    v-show="!hide_logo"
                    src="/images/login_logo.png"
                  ></v-img>
                </v-flex>
                <v-flex xs12 px-4 pt-2 pb-5 style="text-align:center">
                  <div class="title">{{ lang.slogan }}</div>
                </v-flex>
              </v-layout>
              <v-card-text class="pa-0">
                <v-layout wrap>
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex
                        style="text-align:center"
                        v-for="item in socialLogin"
                        :key="item.name"
                        class="social_login mb-2"
                        lg12
                        sm12
                        xs12
                        wrap
                      >
                        <v-btn
                          text
                          row
                          class="white--text mt-0"
                          @click.native="item.click"
                        >
                          <v-img :src="item.icon" height="41" width="250" />
                        </v-btn>
                      </v-flex>
                    </v-layout>
                    <v-card
                      flat
                      v-show="mode == 'login'"
                      v-if="mode == 'login'"
                    >
                      <v-card-title primary-title>
                        <div class="subtitle-2">Or Manual Login</div>
                      </v-card-title>
                      <v-card-text>
                        <div v-if="error_message != ''" class="red--text mb-2">
                          {{ error_message }}
                        </div>
                        <v-form ref="login_form">
                          <v-text-field
                            outlined
                            name="login"
                            v-on:keyup="validateLogin"
                            :label="lang.email"
                            :rules="[valid.required, valid.email]"
                            type="text"
                            v-model="model.username"
                          ></v-text-field>
                          <v-text-field
                            outlined
                            name="password"
                            label="Password"
                            id="password"
                            type="password"
                            v-on:keyup="validateLogin"
                            v-model="model.password"
                            :rules="[valid.required, valid.min]"
                          ></v-text-field>
                          <v-card class="mt-3 mb-4 elevation-0">
                            <a @click="forgetPasswordDialog = true">{{
                              lang.forgot_password
                            }}</a>
                          </v-card>
                        </v-form>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          large
                          block
                          depressed
                          class="no-uppercase"
                          color="primary"
                          @click="signInWidthEmail"
                          >Login</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
    <v-dialog v-model="forgetPasswordDialog" :width="forgetPasswordDialogWidth">
      <v-form ref="forgetPassword" lazy lazy-validation>
        <v-card>
          <v-card-title>
            <span>{{ lang.forget_password }}</span>
          </v-card-title>
          <v-divider class="ma-0"></v-divider>

          <v-container grid-list-sm class="pa-4">
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="forgetPasswordEmail"
                  prepend-icon="email"
                  v-on:keyup="validateForgetPassword"
                  :placeholder="lang.email"
                  :rules="[valid.required, valid.email]"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-btn text color="primary" @click="forgetPasswordDialog = false">{{
              lang.cancel
            }}</v-btn>
            <v-btn text @click="forget_password">{{ lang.submit }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-app>
</template>

<script>
const logs = require("@/classes/logs/logs.js").Logs;
import { mapState } from "vuex";
function reload() {
  setTimeout(function() {
    location.reload();
  }, 200);
}
export default {
  components: {},
  data: () => ({
    hide_logo: false,
    forgetPasswordDialog: false,
    forgetPasswordEmail: "",
    error_message: "",
    socialLogin: [],
    mode: "login",
    model: {
      username: "",
      password: "",
      confirmPassword: "",
    },
    valid: {
      required: (value) => !!value || "Required.",
      min: (v) => v.length >= 6 || "Min 6 characters",
      password_match: (v) => v.length >= 6 || "Password must match",
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
    },
  }),
  mounted() {
    this.valid.password_match = (v) =>
      v == this.model.password || "Password must match";
    this.socialLogin = [
      {
        icon: "/images/login/login_with_google.svg",
        click: this.signInWithGoogle,
      },
    ];
  },
  computed: {
    ...mapState(["userProfile", "currentUser", "loading", "fb", "lang"]),
    forgetPasswordDialogWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "100%";
        case "sm":
          return "70%";
        case "md":
          return "50%";
        case "lg":
          return "50%";
        case "xl":
          return "50%";
      }
    },
  },
  methods: {
    forget_password() {
      if (!this.$refs.forgetPassword.validate()) {
        return;
      }
      var me = this;
      this.$store.commit("loading", true);
      this.fb.auth
        .sendPasswordResetEmail(this.forgetPasswordEmail)
        .then(function() {
          me.forgetPasswordDialog = false;
          me.$toastr("success", me.lang.password_email_sent);
          me.$store.commit("loading", false);
          me.forgetPasswordEmail = "";
        })
        .catch(function(error) {
          me.forgetPasswordDialog = false;
          me.$toastr("error", error);
          me.$store.commit("loading", false);
          me.forgetPasswordEmail = "";
        });
    },
    validateForgetPassword: function(e) {
      if (e.keyCode === 13) {
        this.forget_password();
      }
    },
    validateLogin: function(e) {
      if (e.keyCode === 13) {
        this.signInWidthEmail();
      }
    },

    signInWidthEmail: function() {
      if (!this.$refs.login_form.validate()) {
        return;
      }

      this.error_message = "";
      let me = this;
      this.$store.commit("loading", true);
      this.fb.auth
        .signInWithEmailAndPassword(this.model.username, this.model.password)
        .then(function(result) {
          logs.print("fb.auth.currentUser", result);
          if (result.user && result.user.email == me.model.username) {
            reload();
          }
        })
        .catch(function(error) {
          // Handle Errors here.

          switch (error.code) {
            case "auth/wrong-password":
            case "auth/user-not-found":
              me.error_message = me.lang.wrong_password;
              break;
          }
          me.$store.commit("loading", false);
          // ...
        });
    },

    signInWithGoogle: function() {
      this.error_message = "";
      var fb = this.fb;
      this.$store.commit("loading", true);

      if (!fb.auth.currentUser) {
        // [START createprovider]
        var provider = fb.googleProvider;
        // [END createprovider]
        // [START addscopes]
        provider.addScope("https://www.googleapis.com/auth/plus.login");
        // [END addscopes]
        // [START signin]
        fb.auth
          .signInWithPopup(provider)
          .then(function(result) {
            logs.print("fb.auth.currentUser", result);
            if (result.user) {
              reload();
            }
          })
          .catch((err) => console.error("signInWithGoogle:", err));
        // [END signin]
      } else {
        // [START signout]
        fb.auth.signOut();
        // logs.print("logout");
        // [END signout]
      }
    },
    signOut: function() {
      this.fb.auth
        .signOut()
        .then(() => {
          this.user = null;
        })
        .catch((err) => logs.print(error));
    },
  },
};
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
.h100 {
  height: 100% !important;
}
.white_bg {
  background-color: white !important;
}
.mobile_logo {
  position: absolute;
  top: 0px;
}
.no-uppercase {
  text-transform: none;
}
</style>
